// extracted by mini-css-extract-plugin
export default {"container":"theme_container__xfnKV","postsList":"theme_postsList__znsWa","postDetails":"theme_postDetails__vyJx+"};